<script setup lang="ts">
  import { watch, unref } from 'vue'
  import { useRouter } from 'vue-router'
  import { useLocale } from '@/composables/useLocale'
  import { useTitle } from '@/composables/useTitle'
  import { REDIRECT_NAME } from '@/router/basic'
  import { getWarehouseCode } from './utils/auth'
  import { useI18n } from 'vue-i18n'

  const { antLocale } = useLocale()
  const { title } = useTitle()
  const { currentRoute } = useRouter()
  const { t } = useI18n()

  watch(
    () => currentRoute.value.path,
    () => {
      const route = unref(currentRoute)

      if (route.name === REDIRECT_NAME) {
        return
      }
      const wc = getWarehouseCode()

      title.value = `${t('海外仓')}(${wc})-${route.meta.title}-${t('仓配管理系统')}`
    },
    {
      immediate: true,
    },
  )
</script>

<template>
  <a-config-provider :locale="antLocale" :autoInsertSpaceInButton="false">
    <router-view />
  </a-config-provider>
</template>

<style></style>
